import { API_ENDPOINTS } from '@/constants';
import { apiRequest } from '@/services/client';
import {
  type LoginTokensResponseContract,
  validateLoginTokensResponse,
} from '@/services/shared/contractValidation';
import type { LoginRequest, LoginTokensResponse } from '@/types/auth';
import { logger } from '@/utils/logger';

export const login = async (
  body: LoginRequest,
): Promise<LoginTokensResponse> => {
  try {
    const response = await apiRequest<LoginTokensResponseContract>(
      API_ENDPOINTS.AUTH.LOGIN,
      {
        method: 'POST',
        data: body,
        retry: { retries: 0, retryOnNetworkError: true },
        useGlobalErrorHandler: false,
      },
    );
    return validateLoginTokensResponse(response, {
      operation: 'login',
      endpoint: API_ENDPOINTS.AUTH.LOGIN,
    });
  } catch (error) {
    logger.error('Login request error', {
      scope: 'login_service',
      error,
    });
    throw error;
  }
};
